import {Component, OnInit} from '@angular/core';
import {Aangifte} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder} from "@angular/forms";


@Component({
  selector: 'snelstart-venture-fiscaal-feature-box1-belastbare-inkomsten-op-basis-van-overgangsrecht',
  templateUrl: './box1-belastbare-inkomsten-op-basis-van-overgangsrecht.component.html',
  styleUrls: ['./box1-belastbare-inkomsten-op-basis-van-overgangsrecht.component.scss',],
})
export class Box1BelastbareInkomstenOpBasisVanOvergangsrechtComponent implements OnInit {
  aangifte = {} as Aangifte;

  constructor(private fb: FormBuilder) {
  }
  saveChanges(): void {
    // this.aangifte.aangever = (<Aangever>this.aangever.getRawValue())
    sessionStorage.setItem('entities', JSON.stringify(this.aangifte))
  }

  public ngOnInit(): void {
    this.aangifte={} as Aangifte

  }
}
